import React from "react";
import siteText from "../assets/siteText.json";

function Pets() {
  return (
    <div className="container">
      <h1>{siteText.pets.header}</h1>
      <div style={{display: 'flex', justifyContent: 'center', marginBottom: '2rem'}}>
        <img
          src={require("../assets/optimized/image5.jpg")}
          alt={siteText.pets.imageAlt}
          style={{width: "100%", maxWidth: 600, borderRadius: "14px", boxShadow: "0 4px 18px rgba(0,0,0,0.10)"}}
        />
      </div>
      <p>{siteText.pets.text}</p>
      <p>{siteText.pets.footer}</p>
    </div>
  );
}

export default Pets;
